import moment from "moment/moment";

export function isMobile() {
  // let flag = navigator.userAgent.match(
  //   /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  // );
  var info = navigator.userAgent;
  //通过正则表达式的test方法判断是否包含“Mobile”字符串
  var isPhone = /mobile/i.test(info);
  //如果包含“Mobile”（是手机设备）则返回true

  return isPhone;
}

// UTC -8
export function transTimestamp(
  datetime,
  dateSeprator = "-",
  timeSeprator = ":"
) {
  let d =moment(datetime).format('YYYY-MM-DD HH:mm:ss')
  let time = new Date(d)
  let b =time.getTime()
  // -1000*8*60*60
  // console.log(time,b,'33333333333');
  if (datetime) {
    const date = new Date(b);
    const year = `${date.getFullYear()}`;
    let month = `${date.getMonth() + 1}`;
    let day = `${date.getDate()}`;
    let hour = `${date.getHours()}`;
    let minute = `${date.getMinutes()}`;
    let second = `${date.getSeconds()}`;

    if (month.length === 1) {
      month = `0${month}`;
    }
    if (day.length === 1) {
      day = `0${day}`;
    }
    if (day.length === 1) {
      day = `0${day}`;
    }
    if (hour.length === 1) {
      hour = `0${hour}`;
    }
    if (minute.length === 1) {
      minute = `0${minute}`;
    }
    if (second.length === 1) {
      second = `0${second}`;
    }
    return `${year}${dateSeprator}${month}${dateSeprator}${day} `;
  }
}
